<template>
  <b-row>
    <b-col
      v-for="i in 4"
      :key="i"
      cols="12"
      md="3"
      class="col"
    >
      <Skeleton
        width="100%"
        height="220px"
      />
      <div class="box-content">
        <Skeleton
          v-for="i in 3"
          :key="i"
          width="100%"
          height="22px"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  }
}
</script>

<style lang="scss" scoped>
.row {
  .col {
    margin-bottom: 22px;

    .box-content {
      margin-top: 22px;

      div {
        margin-top: 12px;
      }
    }
  }
}
</style>
